(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modal = document.querySelector('.js-gallery-modal');
    const modalClose = modal.querySelector('.js-gallery-modal__close');
    const $modalSlider = $('.js-gallery-modal__slider');
    const modalTriggers = document.querySelectorAll('.js-gallery-modal-trigger');

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.ariaHidden = true;
      modal.removeAttribute('aria-modal');
      modal.removeAttribute('role');      
    };

    const openModal = (cb = () => null) => {
      modal.classList.add('is-open');
      modal.ariaHidden = false;
      modal.setAttribute('aria-modal', true);
      modal.role = 'dialog';
      modalClose.focus();  
      cb();
    };
    
    $modalSlider.slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="fill:none!important"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="fill:none!important"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });
  
    modalClose.addEventListener('click', e => {
      e.preventDefault();
      closeModal();
    });

    modalTriggers.forEach((item, index) => {
      item.addEventListener('click', e => {
        e.preventDefault();
        openModal(() => {
          $modalSlider.slick('slickGoTo', index);          
        });
      });
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  if (productRecommendationsSection.getAttribute('data-riis-family') === '1') { return; }
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var incoming = container.querySelector(".product-recommendations");
      if (!incoming) { return; }
      productRecommendationsSection.innerHTML = incoming.innerHTML;
      if (theme && theme.ProductBlockManager) theme.ProductBlockManager.loadImages(productRecommendationsSection);
      if (theme && theme.initAnimateOnScroll) theme.initAnimateOnScroll();
    }
  };
  request.send();
};
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
